import Api from 'libs/api';

class UserApi extends Api {
  constructor() {
    super('users');
  }

  getAvailableCompanies = (params = {}) => {
    return this.buildQuery('get', { params }, 'available_companies');
  };
}

export default UserApi;
